import { render, staticRenderFns } from "./ChartSpO2.vue?vue&type=template&id=2f471f7d&scoped=true"
import script from "./ChartSpO2.vue?vue&type=script&lang=js"
export * from "./ChartSpO2.vue?vue&type=script&lang=js"
import style0 from "./ChartSpO2.vue?vue&type=style&index=0&id=2f471f7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f471f7d",
  null
  
)

export default component.exports